/* babel-plugin-inline-import '../../../../shaders/post-processing/copy.glsl' */
const copy = "varying vec2 v_UV;\n\nuniform sampler2D u_Texture;\n\nvoid main() {\n  gl_FragColor = vec4(texture2D(u_Texture, v_UV));\n}";
/* babel-plugin-inline-import '../../../../shaders/post-processing/quad.glsl' */
const quad = "attribute vec2 a_Position;\n\nvarying vec2 v_UV;\n\nvoid main() {\n  v_UV = 0.5 * (a_Position + 1.0);\n  gl_Position = vec4(a_Position, 0., 1.);\n}";
import BasePostProcessingPass from "../BasePostProcessingPass";
export default class CopyPass extends BasePostProcessingPass {
  setupShaders() {
    this.shaderModuleService.registerModule('copy-pass', {
      vs: quad,
      fs: copy
    });
    return this.shaderModuleService.getModule('copy-pass');
  }
}